import * as React from 'react';
import type { IndNote } from '../../MedicareProAPI/Entities/Ind/IndNote';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';

interface NoteContentDisplayProps {
  note: IndNote;
  maxLength?: number;
  isEditing?: boolean;
  onSave?: (newBody: string) => void;
  onCancel?: () => void;
}

export const NoteContentDisplay = ({
  note,
  maxLength = 250,
  isEditing = false,
  onSave,
  onCancel,
}: NoteContentDisplayProps): React.JSX.Element => {
  const [expanded, setExpanded] = React.useState(false);
  const [draft, setDraft] = React.useState(note.getIndNoteBody());
  const [saving, setSaving] = React.useState(false);

  const isLong = draft.length > maxLength;
  const preview = draft.slice(0, maxLength);

  const handleSaveNote = async (draft) => {
    setSaving(true);
    await onSave(draft);
    setSaving(false);
  };

  return (
    <div className="calMess border p-2 rounded mt-3">
      {isEditing ? (
        <>
          <div className="mb-1">
            <small>
              <b>{Utilities.renderReadableDateTime(new Date())}</b>
            </small>
          </div>
          <textarea
            className="form-control"
            rows={4}
            autoFocus
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Write your note..."
          />
          <div className="mt-2">
            <button
              className="btn btn-sm btn-primary mr-2"
              onClick={() => handleSaveNote(draft)}
              disabled={!draft.trim()}
            >
              {saving && (
                <>
                  <i className="far fa-spinner fa-spin"></i> Saving...
                </>
              )}
              {!saving && <>Save</>}
            </button>
            <button className="btn btn-sm btn-secondary" onClick={onCancel}>
              Cancel
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="mb-1">
            <small>
              <b>
                {Utilities.renderReadableDateTime(new Date(note.getRawDate().replace(' ', 'T')))}
              </b>
            </small>
          </div>
          <p>
            <small>
              {expanded || !isLong ? draft : `${preview}...`}
              {isLong && (
                <span
                  onClick={() => setExpanded(!expanded)}
                  className="ml-2 text-primary"
                  style={{ cursor: 'pointer' }}
                >
                  {expanded ? 'Show less' : 'Show more'}
                </span>
              )}
            </small>
          </p>
          <div>
            {note.getIndNoteAuthor() && (
              <span className="badge badge-primary font-weight-normal">
                {note.getIndNoteAuthor()}
              </span>
            )}
          </div>
        </>
      )}
    </div>
  );
};
